import { render, staticRenderFns } from "./TmcPriceUpdatePopup.vue?vue&type=template&id=0a73b096&"
import script from "./TmcPriceUpdatePopup.vue?vue&type=script&lang=js&"
export * from "./TmcPriceUpdatePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports